import React from 'react'
import PropTypes from 'prop-types'

import ReactHtmlParser from 'react-html-parser'

import BButtonGroup from 'react-bootstrap/ButtonGroup'
import Button from '../Button'

import { concatClasses, isFunction, RenderIf } from '../../utils/fns'

const getClassName = (className) => concatClasses('buttonGroup', className)
const getBtnClassName = (checked) => concatClasses('button', checked ? '-checked' : '')

export const ButtonGroup = React.forwardRef(
  (
    { name, value, options, onChange, className, colClassName, children, containerProps, ...props },
    ref,
  ) => {
    const handleClick = (e, targetValue) => {
      e.preventDefault()
      e.stopPropagation()
      if (targetValue === value) {
        return
      }
      onChange(name, targetValue)
    }

    return (
      <BButtonGroup ref={ref} className={getClassName(className)} {...containerProps}>
        {children
          ? isFunction(children)
            ? children({ value, handleClick, getBtnClassName })
            : children
          : options.map((item) => {
              const checked = item.value === value || item.alternativeValue === value
              return (
                <div className={colClassName} key={item.value}>
                  <Button
                    type="button"
                    variant="subAppSelector"
                    value={item.value}
                    className={getBtnClassName(checked)}
                    onClick={(e) => handleClick(e, item.value)}
                    disabled={item.disabled}
                    {...props}
                  >
                    {RenderIf(item.imgSrc, <img className="illustration" src={item.imgSrc} />)}
                    {RenderIf(
                      item.largeText,
                      <div className="button__largeText">{ReactHtmlParser(item.largeText)}</div>,
                    )}
                    {RenderIf(item.text, <div className="button__text">{item.text}</div>)}
                  </Button>
                </div>
              )
            })}
      </BButtonGroup>
    )
  },
)

ButtonGroup.displayName = 'ButtonGroup'

ButtonGroup.propTypes = {
  name: PropTypes.string,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  options: function (props, propName, componentName) {
    if (!isFunction(props.children) && props[propName] === undefined) {
      return new Error(
        `The prop ${propName} is marked as required in ${componentName}, but its value is ${undefined}`,
      )
    }
  },
  onChange: PropTypes.func.isRequired,
  className: PropTypes.string,
  colClassName: PropTypes.string,
  children: PropTypes.oneOfType([PropTypes.object, PropTypes.func]),
  containerProps: PropTypes.object,
}

ButtonGroup.defaultProps = {
  name: 'btnGroup',
}
